export type ParsedCriteria = Readonly<{
  main: string;
  counts?: string;
  doesNotCount?: string;
}>;

/**
 * Splits criteria text into its lead sentence and the trailing
 * "Counts: … Does not count: …" qualifiers. With neither marker present, the
 * whole string is the lead.
 */
export const parseCriteriaText = (text: string): ParsedCriteria => {
  const countsMatch = text.match(/\bCounts:\s*/i);
  const doesNotCountMatch = text.match(/\bDoes not count:\s*/i);

  const splitIdx = countsMatch?.index ?? doesNotCountMatch?.index;

  if (splitIdx == null) return { main: text };

  const main = text.slice(0, splitIdx).trim();
  const countsStart = countsMatch ? (countsMatch.index ?? 0) + countsMatch[0].length : 0;
  const dncStart = doesNotCountMatch
    ? (doesNotCountMatch.index ?? 0) + doesNotCountMatch[0].length
    : 0;

  const counts = countsMatch
    ? text.slice(countsStart, doesNotCountMatch?.index).trim().replace(/\.$/, '')
    : undefined;
  const doesNotCount = doesNotCountMatch
    ? text.slice(dncStart).trim().replace(/\.$/, '')
    : undefined;

  return { main, counts, doesNotCount };
};
